
interface AppTitleProps {
  className?: string;
}

export default function AppTitle({ className = "text-2xl font-bold" }: AppTitleProps) {
  return (
    <h1 className={className}>
      Sistema Parecer Descomplicado com IA
    </h1>
  );
}
